import Vue from 'vue';
import { Backend } from '@/_axios';

// import mutations from './mutations'
// import actions from './actions'
// import moment from 'moment';

export const LOAD_SPECIAL_DAYS = 'LOAD_SPECIAL_DAYS';
export const SET_SPECIAL_DAYS = 'SET_SPECIAL_DAYS';

export const LOAD_SPECIAL_DAYS_BY_PERIOD = 'LOAD_SPECIAL_DAYS_BY_PERIOD';
export const SET_SPECIAL_DAYS_BY_PERIOD = 'SET_SPECIAL_DAYS_BY_PERIOD';

export const SAVE_SPECIAL_DAY = 'SAVE_SPECIAL_DAY';
export const SET_SPECIAL_DAY = 'SET_SPECIAL_DAY';

export const DELETE_SPECIAL_DAY = 'DELETE_SPECIAL_DAY';

const state = {
  specialBusinessDays: {},
  specialBusinessDaysByPeriod: {},
  workDays: {},
};

const getters = {
  specialBusinessDays: (state) => {
    return state.specialBusinessDays;
  },
  specialBusinessDaysByPeriod: (state) => {
    return state.specialBusinessDaysByPeriod;
  }
};

const actions = {
  [LOAD_SPECIAL_DAYS]: function ({ commit }) {
    Backend.get('/api/special-days').then((response) => {
      const specialDays = {};
      response.data.forEach((specialDay) => {
        specialDays[specialDay.id] = specialDay;
        specialDays[specialDay.id].delta_time /= 3600;
      });
      commit('SET_SPECIAL_DAYS', { specialBusinessDays: specialDays });
    });
  },
  [LOAD_SPECIAL_DAYS_BY_PERIOD]: function ({ commit }, { periodFrom, periodTo }) {
    Backend.post('/api/special-days-by-period', { periodFrom: periodFrom, periodTo: periodTo }).then((response) => {
      const specialDays = {
        total_hours: 0,
        byWeeks: {}
      };
      response.data.data.forEach((specialDay) => {
        specialDays.byWeeks[specialDay.year_week] = specialDay;
        specialDays.total_hours -= specialDay.delta_hours;
      });
      commit('SET_SPECIAL_DAYS_BY_PERIOD', specialDays);
    });
  },
  [SAVE_SPECIAL_DAY]: function ({ commit }, { id, date, description, deltaTime }) {
    Backend.post('/api/save-special-day', { data: { id: id, date: date, description: description, deltaTime: deltaTime * 3600 } }).then((response) => {
      response.data.delta_time /= 3600;
      commit('SET_SPECIAL_DAY', response.data);
    });
  },
  [DELETE_SPECIAL_DAY]: function ({ commit }, id) {
    Backend.delete('/api/delete-special-day', { data: { id: id } }).then((response) => {
      commit('DELETE_SPECIAL_DAY', id);
    });
  }
};

const mutations = {
  [SET_SPECIAL_DAYS]: function (state, { specialBusinessDays }) {
    state.specialBusinessDays = specialBusinessDays;
  },
  [SET_SPECIAL_DAYS_BY_PERIOD]: function (state, specialBusinessDaysByPeriod) {
    state.specialBusinessDaysByPeriod = specialBusinessDaysByPeriod;
  },
  [SET_SPECIAL_DAY]: function (state, specialBusinessDay) {
    Vue.set(state.specialBusinessDays, specialBusinessDay.id, specialBusinessDay);
  },
  [DELETE_SPECIAL_DAY]: function (state, id) {
    Vue.delete(state.specialBusinessDays, id);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
